export default __webpack_public_path__ + "static/media/Goal_6.39ae0b85.zip";